import { availableInternationalization, defaultInternationalization } from 'corporate-types';
import formatDate from 'date-fns/format';
import formatISO from 'date-fns/formatISO';
import parse from 'date-fns/parse';
import parseISO from 'date-fns/parseISO';
import zhCN from 'date-fns/locale/zh-CN';
import it from 'date-fns/locale/it';
import enGB from 'date-fns/locale/en-GB';
import enUS from 'date-fns/locale/en-US';
import ru from 'date-fns/locale/ru';
import fr from 'date-fns/locale/fr';
import de from 'date-fns/locale/de';
import nl from 'date-fns/locale/nl';
import es from 'date-fns/locale/es';
import pt from 'date-fns/locale/pt';
import ptBR from 'date-fns/locale/pt-BR';
export const formatTimestamp = (timestamp) => {
    if (timestamp.toString().length <= 10) {
        return timestamp * 1000;
    }
    return timestamp;
};
export const stringToISODate = (date, format, locale) => {
    try {
        return formatISO(parse(date, format, new Date(), {
            locale: fromLocaleToDateLocaleObject(locale)
        }));
    }
    catch (error) {
        return '';
    }
};
export const sirmanDateToDate = (date) => {
    const ms = date ? date.match('([0-9]+)') : null;
    return ms ? new Date(parseInt(ms[0])) : new Date();
};
export const sirmanDateToMs = (date) => {
    const ms = date ? date.match('([0-9]+)') : null;
    return ms ? parseInt(ms[0]) : 0;
};
const fromLocaleToDateLocaleObject = (locale = defaultInternationalization) => {
    switch (locale) {
        case availableInternationalization.ENGLISH_UNITED_KINGDOM: return enGB;
        case availableInternationalization.ENGLISH_UNITED_STATES: return enUS;
        case availableInternationalization.ITALIAN_ITALY: return it;
        case availableInternationalization.FRENCH_FRANCE: return fr;
        case availableInternationalization.GERMAN_GERMANY: return de;
        case availableInternationalization.RUSSIAN_RUSSIA: return ru;
        case availableInternationalization.CHINEESE_CHINA: return zhCN;
        case availableInternationalization.SPANISH_SPAIN: return es;
        case availableInternationalization.DUTCH_NETHERLAND: return nl;
        case availableInternationalization.PORTUGUESE_PORTUGAL: return pt;
        case availableInternationalization.PORTUGUESE_BRAZIL: return ptBR;
    }
};
export const strapiDateConverter = (obj, objType, format, locale) => {
    var _a, _b, _c, _d;
    if (format) {
        switch (objType) {
            case 'workshops':
            case 'news':
                (_b = (_a = obj === null || obj === void 0 ? void 0 : obj.data) === null || _a === void 0 ? void 0 : _a.forEach) === null || _b === void 0 ? void 0 : _b.call(_a, (e) => {
                    var _a, _b;
                    e.attributes.originalDate = (_a = e === null || e === void 0 ? void 0 : e.attributes) === null || _a === void 0 ? void 0 : _a.date;
                    e.attributes.date = e.attributes.date ? formatDate(parseISO((_b = e === null || e === void 0 ? void 0 : e.attributes) === null || _b === void 0 ? void 0 : _b.date), format, {
                        locale: fromLocaleToDateLocaleObject(locale),
                    }) : undefined;
                });
                break;
            case 'events':
                (_d = (_c = obj === null || obj === void 0 ? void 0 : obj.data) === null || _c === void 0 ? void 0 : _c.forEach) === null || _d === void 0 ? void 0 : _d.call(_c, (e) => {
                    var _a, _b, _c;
                    e.attributes.date = formatDate(parseISO((_a = e === null || e === void 0 ? void 0 : e.attributes) === null || _a === void 0 ? void 0 : _a.publishedAt), format, {
                        locale: fromLocaleToDateLocaleObject(locale),
                    });
                    e.attributes.startDate = formatDate(parseISO((_b = e === null || e === void 0 ? void 0 : e.attributes) === null || _b === void 0 ? void 0 : _b.startDate), format, {
                        locale: fromLocaleToDateLocaleObject(locale),
                    });
                    e.attributes.endDate = formatDate(parseISO((_c = e === null || e === void 0 ? void 0 : e.attributes) === null || _c === void 0 ? void 0 : _c.endDate), format, {
                        locale: fromLocaleToDateLocaleObject(locale),
                    });
                });
                break;
        }
    }
    return obj;
};
//# sourceMappingURL=dates.js.map